// Advanced Inventory Feature Constants
export const INVENTORY_REQUEST_INVENTORY_SETTINGS =
  'INVENTORY_REQUEST_INVENTORY_SETTINGS';
export const INVENTORY_SET_INVENTORY_SETTINGS =
  'INVENTORY_SET_INVENTORY_SETTINGS';
